export const transitionDurationSeconds = 0.2;
